import { Event, SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { Content, ContentfulProduct } from 'shared/types/content';
import {
  GetContentAction,
  GetProductContentAction,
  GetProductsContentAction,
  GetProductsContentRawResponse,
} from '../../types/actions/ContentActions';
import { ContentEvents } from '../../types/events/ContentEvents';
import { GetContentQuery, GetProductContentQuery, GetProductsContentQuery } from '../../types/queries/ContentQueries';

export type ContentActions = {
  getContent: GetContentAction;
  getProductContent: GetProductContentAction;
  getProductsContent: GetProductsContentAction;
};

export const getContentActions = (sdk: SDK<ContentEvents>): ContentActions => {
  return {
    getContent: async (
      query: GetContentQuery,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<Content>({
        actionName: 'content/getContent',
        query,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      if (!response.isError) {
        sdk.trigger(
          new Event({
            eventName: 'contentFetched',
            data: {
              result: response.data,
            },
          }),
        );
      }
      return response;
    },
    getProductContent: async (
      query: GetProductContentQuery,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<ContentfulProduct>({
        actionName: 'content/getProductContent',
        query,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      if (!response.isError) {
        sdk.trigger(
          new Event({
            eventName: 'productContentFetched',
            data: {
              product: response.data,
            },
          }),
        );
      }
      return response;
    },
    getProductsContent: async (
      query: GetProductsContentQuery,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<GetProductsContentRawResponse>({
        actionName: 'content/getProductsContent',
        query,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      if (!response.isError) {
        sdk.trigger(
          new Event({
            eventName: 'productsContentFetched',
            data: response.data,
          }),
        );
      }
      return response;
    },
  };
};
